import { FunctionComponent } from 'react';

import { SearchIndex } from '@kanda-libs/ks-frontend-services';

import CompanySearchTable from './CompanySearchTable';
import CreditSearchTable from './CreditSearchTable';
import JobSearchTable from './JobSearchTable';

interface TableProps {
  index?: SearchIndex;
}

const Table: FunctionComponent<TableProps> = function ({ index }) {
  if (!index) return null;
  return (
    <div className="flex flex-col flex-1 w-full border border-t-0 border-neutral-300 rounded-b-lg p-3">
      {index === 'company' && <CompanySearchTable />}
      {index === 'credit' && <CreditSearchTable />}
      {index === 'job' && <JobSearchTable />}
    </div>
  );
};

export default Table;
